<template>
  <PageContainer>
    <NavPanel variant="secondary" :links="links" />
  </PageContainer>
</template>

<script setup lang="ts">
import { PageContainer } from '@tallo/design-system';

import { NavPanelLink } from './nav-panel-link.interface';
import NavPanel from './nav-panel.vue';

/** The tab row under the app header that a property page and a building page share */
defineProps<{ links: NavPanelLink[] }>();
</script>
